"use strict";

exports.__esModule = true;
exports.DeviceGridElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _FlexGrid = require("../../Core/FlexGrid/FlexGrid");
var _DeviceContext = require("../../Device/DeviceContext");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _Core = require("../../Core");
var _UserActions = require("../../UserActions");
var _DeviceStatusOverlay = require("../../Device/DeviceStatusOverlay");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Time = require("../../Time");
var _MetricValueBatchProvider = require("../MetricValue/MetricValueBatchProvider");
var _Theme = require("../../Theme");
var _TileContext = require("../common/TileContext");
var _excluded = ["device", "x", "y", "width", "height"];
var _dec, _dec2, _dec3, _class, _DeviceGridElement;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// Each device is a white shadow card; the template Grid inside draws the
// state-coloured edge and the card's lines.
var DeviceGridElementContainer = _styledComponents["default"].article.withConfig({
  displayName: "DeviceGridElementmodern__DeviceGridElementContainer",
  componentId: "sc-1pudb8s-0"
})(["position:absolute;box-sizing:border-box;border-radius:12px;background:#ffffff;box-shadow:", ";overflow:hidden;"], (0, _Theme.val)("CardShadow"));
var DeviceGridElementContainerLink = (0, _styledComponents["default"])(_reactRouterDom.Link).withConfig({
  displayName: "DeviceGridElementmodern__DeviceGridElementContainerLink",
  componentId: "sc-1pudb8s-1"
})(["position:absolute;box-sizing:border-box;border-radius:12px;background:#ffffff;box-shadow:", ";overflow:hidden;transition:box-shadow 120ms ease;&:hover{color:inherit;box-shadow:", ";}"], (0, _Theme.val)("CardShadow"), (0, _Theme.val)("CardShadowRaised"));

/**
 * Displays a virtualized grid of devices, repeating the supplied
 * element children for each device.
 */
var DeviceGridElement = exports.DeviceGridElement = (_dec = _ConfigurableLayout.LayoutSettingsContext.withContext, _dec2 = _Core.SelectionContext.withContext, _dec3 = _Time.ReportingPeriodContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = (_DeviceGridElement = /*#__PURE__*/function (_Component) {
  function DeviceGridElement() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      range: null
    };
    // Metric requests are batched for the devices currently on screen.
    _this.onItemsRendered = function (_ref) {
      var overscanStartIndex = _ref.overscanStartIndex,
        overscanStopIndex = _ref.overscanStopIndex;
      var geometry = _this.visibleGeometry;
      if (!geometry) {
        return;
      }
      var perRow = geometry.perRow || 1;
      var count = geometry.count;
      if (count <= 0) {
        return;
      }
      var next = {
        start: Math.max(0, overscanStartIndex) * perRow,
        stop: Math.min(count - 1, (overscanStopIndex + 1) * perRow - 1)
      };
      _this.setState(function (prev) {
        if (prev.range && prev.range.start === next.start && prev.range.stop === next.stop) {
          return null;
        }
        return {
          range: next
        };
      });
    };
    _this.getDevices = function (deviceList) {
      var selection = _this.props.selection;
      if (selection && selection.selected && selection.selected.deviceList) {
        return deviceList.filter(function (device) {
          return selection.selected.deviceList.includes(device.uuid);
        });
      }
      return deviceList;
    };
    _this.renderDevice = function (_ref2) {
      var device = _ref2.device,
        x = _ref2.x,
        y = _ref2.y,
        width = _ref2.width,
        height = _ref2.height,
        extra = _objectWithoutPropertiesLoose(_ref2, _excluded);
      var _this$props = _this.props,
        children = _this$props.children,
        render = _this$props.render,
        itemBackgroundColor = _this$props.itemBackgroundColor,
        onClickAction = _this$props.onClickAction,
        layoutSettings = _this$props.layoutSettings;
      var transform = "translate3d(" + (x + 1) + "px, " + (y + 1) + "px, 0)";
      var style = {
        transform: transform,
        width: width - 2,
        height: height - 2,
        backgroundColor: itemBackgroundColor || "#ffffff"
      };
      var body = /*#__PURE__*/_react["default"].createElement(_TileContext.DeviceCardContext.Provider, {
        value: true
      }, _react["default"].Children.map(render(children), function (child) {
        return /*#__PURE__*/_react["default"].cloneElement(child, Object.assign({
          width: width - 2,
          height: height - 2
        }, extra));
      }));
      if (onClickAction) {
        return /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Provider, {
          key: device.uuid,
          value: device
        }, /*#__PURE__*/_react["default"].createElement(_UserActions.UserAction, onClickAction, function (_ref3) {
          var invoke = _ref3.invoke,
            getURL = _ref3.getURL;
          return /*#__PURE__*/_react["default"].createElement(DeviceGridElementContainerLink, {
            style: style
            // Router v5 accepted a `to` function receiving the current
            // location; v6 removed it and only takes a string/Path, so the
            // function was never invoked and every action link resolved to
            // "/". "." is v6's "stay at the current location", matching the
            // old fallback. Same form as DeviceTableElement.
            ,
            to: getURL ? getURL() : ".",
            onClick: invoke
          }, layoutSettings.deviceStatus.enabled && /*#__PURE__*/_react["default"].createElement(_DeviceStatusOverlay.DeviceStatusOverlayController, {
            device: device
          }), body);
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(DeviceGridElementContainer, {
        key: device.uuid,
        style: style
      }, layoutSettings.deviceStatus.enabled && /*#__PURE__*/_react["default"].createElement(_DeviceStatusOverlay.DeviceStatusOverlayController, {
        device: device
      }), /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Provider, {
        value: device
      }, body));
    };
    return _this;
  }
  _inheritsLoose(DeviceGridElement, _Component);
  var _proto = DeviceGridElement.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      width = _this$props2.width,
      height = _this$props2.height,
      itemWidth = _this$props2.itemWidth,
      itemHeight = _this$props2.itemHeight,
      itemBackgroundColor = _this$props2.itemBackgroundColor,
      itemBorderColor = _this$props2.itemBorderColor,
      x = _this$props2.x,
      y = _this$props2.y,
      columnGutter = _this$props2.columnGutter,
      rowGutter = _this$props2.rowGutter,
      onClickAction = _this$props2.onClickAction;
    return /*#__PURE__*/_react["default"].createElement(_DeviceListContext.DeviceListContext.Consumer, null, function (deviceList) {
      var devices = _this2.props.dataRange === "SELECTION" ? _this2.getDevices(deviceList) : deviceList;
      var count = (devices == null ? void 0 : devices.length) || 0;
      var perRow = Math.floor(width / (itemWidth + columnGutter)) || 1;
      _this2.visibleGeometry = {
        perRow: perRow,
        count: count
      };
      var rowCount = Math.ceil(count / perRow) || 0;
      var rowRange = seedListRange(rowCount, height, itemHeight + rowGutter);
      var seeded = {
        start: rowRange.start * perRow,
        stop: count <= 0 ? -1 : Math.min(count - 1, (rowRange.stop + 1) * perRow - 1)
      };
      var range = _this2.state.range || seeded;
      var visibleDevices = sliceDevices(devices, range.start, range.stop);
      return /*#__PURE__*/_react["default"].createElement(_MetricValueBatchProvider.MetricValueBatchProvider, {
        devices: devices,
        visibleDevices: visibleDevices,
        elements: _this2.props.children,
        backgroundColorSource: _this2.props.backgroundColorSource
      }, /*#__PURE__*/_react["default"].createElement(_FlexGrid.FlexGrid, {
        width: width,
        height: height,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        columnGutter: columnGutter,
        rowGutter: rowGutter,
        itemCount: devices == null ? void 0 : devices.length,
        devices: devices,
        onItemsRendered: _this2.onItemsRendered,
        renderItem: function renderItem(_ref4) {
          var index = _ref4.index;
          return /*#__PURE__*/_react["default"].createElement(_Core.DebouncedRender, {
            key: index,
            device: devices[index]
          }, _this2.renderDevice);
        }
      }));
    });
  };
  return DeviceGridElement;
}(_react.Component), _DeviceGridElement.defaultProps = {
  width: 1024,
  height: 768,
  itemBorderColor: "rgba(0, 0, 0, 0.2)",
  columnGutter: 16,
  rowGutter: 16,
  layoutSettings: undefined,
  selection: undefined,
  reportingPeriod: undefined
}, _DeviceGridElement)) || _class) || _class) || _class);
function seedListRange(itemCount, listHeight, itemSize) {
  var count = itemCount || 0;
  if (count <= 0) {
    return {
      start: 0,
      stop: -1
    };
  }
  var size = itemSize > 0 ? itemSize : 1;
  var visible = Math.ceil(Math.max(0, listHeight) / size);
  var stopIndex = Math.max(0, Math.min(count - 1, visible - 1));
  return {
    start: 0,
    stop: Math.min(count - 1, stopIndex + 2)
  };
}
function sliceDevices(devices, start, stop) {
  if (!devices || stop < start || start < 0) {
    return [];
  }
  return devices.slice(start, stop + 1);
}